"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlatformConfig = void 0;
var PlatformConfig = {
    defaultDrawDistance: 250,
    supportsOffsetCorrection: false,
    trackAverageRenderTimeForOffsetProjection: false,
};
exports.PlatformConfig = PlatformConfig;
//# sourceMappingURL=PlatformHelper.js.map